import BaseRequest from '../communicate/BaseRequest'

export default class CommentRequest extends BaseRequest {

  getModelName () {
    return 'comment'
  }

  addComment(data) {

  }
  
}



// WEBPACK FOOTER //
// ./src/request/CommentRequest.js